import React from "react";
import "./style.css";

export default function Philhealth() {
  return (
    <div className="subscriber-philhealth-section">
      {/* <h1 className="subscriber-philhealth-title">PhilHealth Accreditated</h1> */}
      <div className="subscriber-philhealth-container">
        <img alt="PhilHealth" src="/assets/logo/philhealth.png" />
        <span>Accreditated</span>
      </div>
    </div>
  );
}
